'use es6';

import { TestMessageCreateResponse, TestMessageQueryResponse } from '../data/TestMessage';
const CRM_APP_ID = '22712';
const createTestEmailUrl = (appId, email) => `facsimile/v1/test/app/${appId}/email/${email}`;
const queryTestEmailUrl = emailId => `facsimile/v1/test/email/${emailId}`;
export const createTestEmail = (apiClient, emailAddress) => apiClient.post(createTestEmailUrl(CRM_APP_ID, emailAddress)).then(TestMessageCreateResponse);
export const queryTestEmail = (apiClient, emailGuid) => apiClient.get(queryTestEmailUrl(emailGuid)).then(TestMessageQueryResponse);